export default __webpack_public_path__ + "xpt-logo-with-name.0930a772.png";